import { Link } from "gatsby"
import React from "react"
import { Navbar, Container } from 'react-bootstrap'
import ButtonIcon from '../icon/buttonIcon'
import DropdownIcon from '../icon/dropdownIcon'
import ScheduleCallIcon from '../icon/scheduleCallIcon'
import '../../sass/global/navbar.scss'

const Header = () => {
    
    return (
        <Navbar id="navbar" expand="xl" fixed="top" className="scrollMenuTop nav-bg-transparent">
            <Container className="h-100">
                <Navbar.Brand href="/">
                <img src="/wowmakers-logo.svg" width="215" height="35" alt="WowMakers Logo" style={{ marginBottom: '0' }}/>
                </Navbar.Brand>
                <button className="navbar-toggle collapsed d-xxl-none d-xl-none" id="navbar-toggle">
                    <span className="icon-bar"></span>
                    <span className="icon-bar"></span>
                    <span className="icon-bar"></span>                    
                </button>
                <Navbar.Collapse id="navbarNav">
                    <ul className="navbar-nav ml-auto">
                        <li className="nav-dropdown">
                            <a href="/#" title="Services" role="button" className="nav-link">
                                <span>Services</span>
                                <span><DropdownIcon /></span>
                            </a>
                            <div className="dropdown-menu">
                                <div className="dropdown-menu-content">
                                    <ul>
                                        <li>
                                            <Link to="/branding/" className="list-group-item-action">
                                                <div>
                                                    <span>Branding</span>
                                                </div>
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/ai-video-agency/" className="list-group-item-action">
                                                <div>
                                                    <span>AI Video</span>
                                                </div>
                                            </Link>
                                        </li>                                                                                
                                        <li>
                                            <Link to="/animated-explainer-video/" className="list-group-item-action">
                                                <div>
                                                    <span>Explainer Video</span>
                                                </div>
                                            </Link>
                                        </li>
                                                                                
                                    </ul>
                                </div>
                            </div>
                        </li>                        
                        <li>
                            <Link to="/case-studies/" activeClassName="active" className="nav-link hover-animation">Work</Link>
                        </li>                        
                        <li>
                            <Link to="/about" activeClassName="active" className="nav-link hover-animation">About</Link>
                        </li>
                        <li>
                            <Link to="/blog/" activeClassName="active" className="nav-link hover-animation">Blog</Link>
                        </li>
                        <li className="schedule-a-call">
                            <a href="#CQL" className="btn drift-chat-popup" >
                                <ScheduleCallIcon />
                                <span>Schedule a call</span>
                            </a>
                        </li>
                        <li className="contact-cta">
                            <Link to="/contact" className="btn wowaction-btn">
                                <ButtonIcon />
                                <span>Contact</span>
                            </Link> 
                        </li>
                    </ul>
                </Navbar.Collapse>
            </Container>
        </Navbar>       
    )
}

export default Header


